import axios from 'axios';
import { API_BASE } from './apiBase';

async function request(method, path, params) {
  const token = localStorage.getItem('token');
  if (!token) throw new Error('Session absente');
  const response = await axios({ method, url: `${API_BASE}/lead-followup/${path}`, params,
    headers: { Authorization: `Bearer ${token}` } });
  if (token !== localStorage.getItem('token')) throw new Error('Session modifiée');
  if (!response.data.success) throw new Error(response.data.message || 'Suivi indisponible');
  return response.data.data;
}

export const getLeadFollowupSummary = () => request('get', 'summary');
export const getOverdueLeads = params => request('get', 'leads', params);
export const claimLeadFollowupReminder = () => request('post', 'remind');
